<template>
  <div>
    <template v-if="!isComplete">
      Загружается...
    </template>
    <template v-else-if="page.items.length > 0">
    <table class="table-custom">
      <thead>
      <tr>
        <th style="width: 5%"></th>
        <th>Должность</th>
        <th>З/п, руб</th>
        <th>График работы</th>
        <th>Тип занятости</th>
        <th>Опыт работы, лет</th>
        <th>Профессиональная область</th>
        <th>Для ЛРАС</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item) in page.items" v-bind:key="item.id" @dblclick="editCard(item.id)">
        <td>
          <menu-component class="actions" :actions="actions(item)"/>
        </td>
        <td>{{item.position}}</td>
        <td>{{getSalaryRange(item)}}</td>
        <td>{{item.scheduleType?.name}}</td>
        <td>{{item.employmentType?.name}}</td>
        <td>{{item.workExperience}}</td>
        <td>{{item.professionArea?.name}}</td>
        <td><i v-if="item.isForPatient" class="fas fa-check"></i></td>
      </tr>
      </tbody>
    </table>
    </template>
    <template v-else>
      <EmptyListMessage/>
    </template>
    <div class="mt-2">
      <button-component v-if="!isReadonly" @click='editCard(0)'>Создать</button-component>
    </div>
    <section class="modals">
      <modal-component v-if="modal.show" title="Карточка вакансии" @close="modal.show = false">
        <vacancy-item-card :vacancy-id="vacancyId" :vacancy-item-id="modal.id" :is-readonly="modal.isReadonly"
                           @close="modal.show = false" @save="onSave"/>
      </modal-component>
    </section>
  </div>
</template>

<script>
import MenuComponent from "@/common/ui/components/page/MenuComponent";
import API from "../api/vacancyItem";
import Constants from '@/common/constants'
import EmptyListMessage from "@/common/components/EmptyListMessage";
import ModalComponent from "../../../common/ui/ModalComponent";
import VacancyItemCard from "../views/VacancyItemCard";
import ButtonComponent from "../../../common/ui/ButtonComponent";
export default {
  name: "VacancyTabItems",
  components: {ButtonComponent, VacancyItemCard, ModalComponent, EmptyListMessage, MenuComponent},
  props: {
    vacancyId: {
      type: Number,
      required: true
    },
    isReadonly: {
      type: Boolean
    }
  },
  watch: {
    vacancyId(newVal) {
      this.request.vacancyId = newVal;
      this.loadPage();
    }
  },
  data() {
    return {
      isComplete: false,
      modalOpen: false,
      request: {
        pageNumber: 1,
        pageSize: 0
      },
      page: {},
      modal: {
        id: null,
        show: false,
        isReadonly: false
      }
    }
  },
  methods: {
    actions(item) {
      let result = [
        {
          title: 'Просмотр',
          icon: 'eye',
          click: () => this.viewCard(item.id)
        }
      ];
      if (!this.isReadonly) {
        result = result.concat([
          {
            title: 'Редактировать',
            icon: 'pen',
            click: () => this.editCard(item.id)
          },
          {
            title: 'Удалить',
            icon: 'trash',
            click: () => this.deleteCard(item.id)
          }
        ]);
      }
      return result;
    },
    loadPage() {
      this.isComplete = false;
      API.search(this.request)
          .then((response) => {
            this.page = response.data;
            this.isComplete = true;
          })
          .catch(() => {
            this.isComplete = true;
          });
    },
    viewCard(id) {
      this.modal.id = id;
      this.modal.show = true;
      this.modal.isReadonly = true;
    },
    editCard(id) {
      if (!this.isReadonly) {
        this.modal.id = id;
        this.modal.show = true;
        this.modal.isReadonly = false;
      } else {
        this.viewCard(id);
      }
    },
    deleteCard(id) {
      Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
        if (res.isConfirmed) {
          API.delete(id).then((response) => {
            Constants.alert.fire('Удаление', response.data.message, response.data.success ? 'success' : 'error');
            this.loadPage();
          });
        }
      });
    },
    getSalaryRange(item) {
      let result = item.salaryFrom || '';
      if (item.salaryTo) result += (result ? ' - ' + item.salaryTo : item.salaryTo);
      return result;
    },
    onSave() {
      this.modal.show = false;
      this.loadPage();
    }
  }
}
</script>

<style scoped>

</style>